/* eslint-disable react/jsx-no-target-blank */
import InformacionAgente from "components/MisDatosForm/InformacionAgente";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import arrendatario from "../assets/arrendatario.svg";
import propietario from "../assets/propietario.svg";
import arrendador from "../assets/arrendador.png";
import { SimpleWrapper } from "../componentes/contenedores";
import { DropDownFilter, TextInput } from "../componentes/entradas";
import useRellenarLocaciones from "../useRellenarLocaciones";
import { OpcionesContratante } from "./opciones";
import { regex } from "utils/validaciones";
import { useSelector } from "react-redux";
import SimpleContainer from "components/InputsMex/containers/SimpleContainer";
import { useFormContext } from "react-hook-form";
import useUsuario from "hooks/useUsuario";
import { emailRegex, inputNumericoEnteros } from "components/InputsMex/validaciones";

const defaultDisclaimer = `
Al enviar mis datos autorizo que AIG Seguros México, S.A. de C.V.  me contacte vía telefónica a través de un asesor de seguros para seguimiento o apoyo a mi cotización. ¡Gracias por tu confianza! <br> <a href="https://www.aig.com.mx/content/dam/aig/lac/mexico/documents/forms/aig_aviso_de_privacidad_febrero_2020.pdf"
target="_blank" class="text-lightblue cpointer w-100">Revisa nuestro aviso de privacidad aquí</a>
`;

const defaultDisclamerSumas = `En este portal podrás cotizar y emitir con un valor límite en las Sumas Aseguradas, en caso de requerir más monto a las permitidas, puedes ingresar solicitud de cotización a través de <p class="d-inline text-lightblue">OrdenesdeTrabajo.Mexico@aig.com</h1>`;

const pathCodPostal = "datosCliente.codigoPostal";
const pathEstado = "datosCliente.estado";
const pathMunicipio = "datosCliente.municipio";
const pathColonia = "datosCliente.colonia";

const opcionesContratante = [
  { img: propietario, label: "Propietario", value: 1 },
  { img: arrendatario, label: "Arrendatario", value: 2 },
];

const opcionesContratanteLogged = [
  { img: propietario, label: "Propietario", value: 1 },
  { img: arrendatario, label: "Arrendatario", value: 2 },
  { img: arrendador, label: "Arrendador", value: 3 },
];

const MisDatosForm = ({
  disclaimer = defaultDisclaimer,
  inputs = [],
  catalogo = {},
  clavesAgente = [],
  opcionesPlan = [],
}) => {
  const {
    componenteCodigoPostal,
    componenteEstado,
    componenteMunicipio,
    componenteColonia,
  } = useRellenarLocaciones({
    names: {
      codPostal: pathCodPostal,
      estado: pathEstado,
      municipio: pathMunicipio,
      colonia: pathColonia,
    },
    catalogoEstados: catalogo?.estados,
  });

  const {
    dataUsuario: { userIsLoggedIn },
  } = useSelector((state) => state.datosUsuarios);
  const { isAgente } = useUsuario();
  const { watch } = useFormContext();

  const planSeleccionado = watch("datosCliente.planSeleccionado");

  useEffect(() => {
    setOpcionesMoneda([
      ...(opcionesPlan?.find((opc) => opc.id === planSeleccionado)?.tipoMoneda || []),
    ]);
    setCatastroficas(
      opcionesPlan?.find((opc) => opc.id === planSeleccionado)?.coberturasCatastroficas ||
        false
    );
  }, [planSeleccionado, opcionesPlan]);

  const [catastroficas, setCatastroficas] = useState(false);
  const [opcionesMoneda, setOpcionesMoneda] = useState([]);

  return (
    <div className='d-flex justify-content-center'>
      <div className='col-lg-10 col-12'>
        <div className='row w-100'>
          <div className='col-12 col-md-6'>
            <div className='container-accidentes'>
              <h3
                className='font-mex text-primary text-center'
                style={{ fontSize: "30px" }}>
                ¿Qué tipo de contratante eres?
              </h3>

              <OpcionesContratante
                name='datosCliente.tipoContratante'
                rules={{ required: regex.requiredMessage }}
                opciones={isAgente ? opcionesContratanteLogged : opcionesContratante}
              />

              {/* Inicio locaciones */}
              <div className='form-group'>{componenteCodigoPostal}</div>
              <div className='form-group'>{componenteEstado}</div>
              <div className='form-group'>{componenteMunicipio}</div>
              <div className='form-group'>{componenteColonia}</div>
              {isAgente && (
                <>
                  <div className='form-group'>
                    <SimpleContainer label='Plan' name='datosCliente.planSeleccionado'>
                      <DropDownFilter
                        name='datosCliente.planSeleccionado'
                        optionLabel='descripcion'
                        optionValue='id'
                        options={opcionesPlan}
                        helpText={"Seleccione un Plan"}
                        rules={{ required: "Este campo es obligatorio" }}
                      />
                    </SimpleContainer>
                  </div>
                  {planSeleccionado === "hogarCotizadorFlex" && (
                    <div className='form-group'>
                      <SimpleContainer label='Moneda' name='datosCliente.moneda'>
                        <DropDownFilter
                          name='datosCliente.moneda'
                          optionLabel='modNombre'
                          optionValue='modCodigoCore'
                          options={opcionesMoneda}
                          helpText={"Seleccione  moneda"}
                          rules={{ required: "Este campo es obligatorio" }}
                        />
                      </SimpleContainer>
                    </div>
                  )}
                  {planSeleccionado === "hogarCotizadorFijo" && (
                    <div className='form-group'>
                      <div className='row mt-3'>
                        <div className='col-8 py-0 d-flex align-items-center'>
                          ¿Vas a contratar coberturas catastróficas?
                        </div>
                        <div className='col-2'>
                          <label className='containerCheckH textComboBoxHogar'>
                            Si
                            <input
                              type='checkbox'
                              name='datosCliente.coberturasCatastroficas'
                              checked={catastroficas}
                              onChange={(evt) => {
                                setCatastroficas(evt.target.checked);
                              }}
                            />
                            <span className='checkmarkH comboHogar'></span>
                          </label>
                        </div>
                        <div className='col-2'>
                          <label className='containerCheckH textComboBoxHogar'>
                            No
                            <input
                              type='checkbox'
                              checked={!catastroficas}
                              onChange={(evt) => {
                                setCatastroficas(!evt.target.checked);
                              }}
                            />
                            <span className='checkmarkH comboHogar'></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}

              {/* Fin locaciones */}
            </div>
          </div>
          <div className='col-12 col-md-6  py-4'>
            <div className='container-accidentes'>
              <h3 className='font-mex text-center' style={{ fontSize: "30px" }}>
                Datos personales
              </h3>
            </div>

            {inputs.includes("usuNombre") && (
              <div className='form-group'>
                <SimpleWrapper label='Nombre*' name='datosCliente.usuNombre'>
                  <TextInput
                    inputProps={{
                      name: "datosCliente.usuNombre",
                      type: "string",
                    }}
                    rules={{
                      required: regex.requiredMessage,
                      pattern: {
                        value: regex.nombre.value,
                        message: regex.nombre.mensaje,
                      },
                    }}
                  />
                </SimpleWrapper>
              </div>
            )}

            {inputs.includes("usuTelefono") && (
              <React.Fragment>
                <div className='form-group'>
                  <SimpleWrapper label='Teléfono*' name='datosCliente.usuTelefono'>
                    <TextInput
                      inputProps={{
                        name: "datosCliente.usuTelefono",
                        type: "number",
                        onKeyDown: inputNumericoEnteros,
                      }}
                      extrasClasses='hide-arrows'
                      rules={{
                        required: regex.requiredMessage,
                        pattern: {
                          value: regex.telefono10.value,
                          message: regex.telefono10.mensaje,
                        },
                        minLength: {
                          value: 10,
                          message: "Debe ingresar mínimo 10 números",
                        },
                        maxLength: {
                          value: 20,
                          message: "Solo puede ingresar máximo 20 números",
                        },
                      }}
                    />
                  </SimpleWrapper>
                </div>
                <div className='form-group container-accidentes'>
                  <p
                    className='text-enviar-cotizacion'
                    style={{ fontSize: "20px", fontFamily: "Futura-Medium" }}>
                    Compártenos tu correo para enviarte tu cotización
                  </p>
                </div>
              </React.Fragment>
            )}

            {inputs.includes("usuCorreo") && (
              <div className='form-group'>
                <SimpleWrapper label='Correo*' name='datosCliente.usuCorreo'>
                  <TextInput
                    inputProps={{
                      name: "datosCliente.usuCorreo",
                    }}
                    rules={{
                      required: regex.requiredMessage,
                      validate: {
                        email: (value) => {
                          if (value === "") {
                            return true;
                          }
                          const valid = emailRegex.test(value);
                          if (!valid) {
                            return "Ingrese un correo válido";
                          }
                          return true;
                        },
                      },
                    }}
                  />
                </SimpleWrapper>
              </div>
            )}

            {inputs.includes("disclaimerTerminos") && (
              <div className='container-accidentes'>
                {isAgente && (
                  <div
                    className='disclaimer-form-datos'
                    style={{
                      textAlign: "justify",
                      fontSize: "15px",
                      fontFamily: "Futura-Medium",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: defaultDisclamerSumas,
                    }}
                  />
                )}

                <div
                  className='disclaimer-form-datos mt-3'
                  style={{ fontSize: "15px", fontFamily: "Futura-Medium" }}
                  dangerouslySetInnerHTML={{
                    __html: disclaimer,
                  }}
                />
              </div>
            )}
            <InformacionAgente
              className='mt-3'
              border={false}
              options={clavesAgente}
              userIsLoggedIn={userIsLoggedIn}
            />
            <div className='d-flex justify-content-center mt-5'>
              <Button type='submit' className='w-75'>
                CONTINUAR
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MisDatosForm;
